import {
    Alert,
    Box,
    Card,
    Divider,
    Grid,
    Snackbar,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton,
} from '@mui/material';
import React, { useContext, useEffect, useState, useRef, useCallback } from 'react';
import { ArrowBack, ExpandMore as ExpandMoreIcon, Warning, Square } from '@mui/icons-material';
import '../../../styles/cssStyles.css';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button, Link, Typography, UtilityIcon } from '@uhc-tempo/components';
import { FormContext } from '../../../context/Form.context';
import styles from '../../../styles/PageStyles.js';
import theme from '../../../styles/PageTheme';
import AverageThresholdTag from './AvgTag.component';
import UnitMeasureMessage from './UnitMeasureMessage.component';
import GeoAverageCost from './GeoAvgCost.component';
import ServiceNoteDisclaimers from './ServiceNoteDisclaimers.component';
import { useReactToPrint } from 'react-to-print';
import DisclaimersText from '../../member/components/DisclaimersText.component';
import OtherLocationsModal from './OtherLocationsModal.component';
import OtherFacilitiesModal from './OtherFacilitiesModal.component';
import FulfillmentService from '../../../API/FulfillmentService';
import CopyEstimate from './CopyEstimate.component';
import FlagIcon from '@mui/icons-material/Flag';
import CloseIcon from '@mui/icons-material/Close';
import { formatFulfillmentRequest } from '../../../utils/FormatFunctions';
import useDetectMobile from '../../../utils/customHooks/useDetectMobile';
import {
    getAppliedToDeductible,
    getCoinsurance,
    getCoPay,
    getMemberPays,
    getTotalBeforeCoverage,
} from '../../../utils/costBreakdownUtil';
import {
    displayProviderName,
    displayProviderSpecialty,
    checkIfSecondFacilityClaim,
    getCardTitle,
    getProviderType,
    checkIfClaimIsGACOnly,
    checkiIfRenderPhysicianAndFacility,
    checkDisplayProviderCard,
    determineCostShareClaimType,
} from '../../../utils/EstimateDisplay.util.js';
import OONTextBlockJSX from './OONTextBlock';
import {
    ESTIMATES_ROUTE,
    FAMILY_DEDUCTIBLE,
    INDIVIDUAL_DEDUCTIBLE,
    LOGIN_ROUTE,
    OUT_NETWORK_TIER,
    SEARCH_ROUTE,
    SINGLE_ESTIMATE_ROUTE,
    PER_UNIT_MEASURES,
    INDEMNITY_NO_RATES,
    VISION_DISCLAIMERS,
    UMR_SOURCECODE,
} from '../../../constants/index';
import {
    renderNoOonCoverageDisclaimer,
    renderPlanSummaryAccumulators,
    checkIfValidAccumulatorData,
    checkOonCoverage,
} from './PlanSummary.components';
import { useHistory } from 'react-router-dom';
import sendEstimateButtonLabel from '../../../utils/customHooks/sendEstimateButtonLabel';
import { determineSingleEstimateFamilyStatusIndicator } from '../../../utils/PlanBenefitsUtil';
import {
    checkForHidingSendEstimateButton,
    estimateSuppressedByCustomDisclaimer,
    getServiceNameToDisplay,
    unitMeasureMessage,
    showRentalDuration,
    rentalDurationText,
    rentalPeriodText,
    estimatedCostDisplaySingle,
    unitMessage,
    showPerUnitMeasure,
} from '../../../utils/EstimatePageUtil';
import PacGacDisclaimer from './PacGacDisclaimer';
import PrintEstimateOrResultsButton from './PrintEstimateOrResultsButton';
import EstimateToggleComponentSingleEstimate from './EstimateToggleSingleEstimate.component';
import { ESTIMATE_HISTORY_TYPES } from '../../../constants';
import { checkIndemnityCoverages } from '../../../utils/SearchPageUtil';
import { AgeRestrictionMessage } from './AgeRestrictionMessageUtil';
import VisionEstimateComponent from './VisionEstimateComponent.component.js';
import { apm } from '@elastic/apm-rum';
import PriorAuthDialog from '../../search/components/PriorAuthDialog.js';
const classes = styles(theme);
export default function SingleEstimatesPage(props) {
    const {
        provider,
        currentSelectedServiceForDisplay,
        otherLocationsOpen,
        setOtherLocationsOpen,
        topLocation,
        setTopLocation,
        setLoading,
        loading,
        setProvider,
        setCurrentSelectedServiceForDisplay,
    } = props;

    const serviceInfo = currentSelectedServiceForDisplay;
    const {
        formValues,
        handleReset,
        integrationType,
        estimateResponse,
        singleEstimateResponse,
        setSingleEstimateResponse,
        memberDetails,
        handleChangeCustom,
        getIncrementedCorId,
        planBenefits,
        visionEstimateResponse,
    } = useContext(FormContext);

    const costShare = singleEstimateResponse?.costShare;
    const geoAverageCost = singleEstimateResponse?.geoAverageCost;
    const costScale = singleEstimateResponse?.costScale;
    const hasNoVisionCost = !visionEstimateResponse;
    const inNetworkBenefits = visionEstimateResponse?.inNetworkBenefits?.[0];
    const outOfNetworkBenefits = visionEstimateResponse?.outOfNetworkBenefits?.[0];
    const hasNoCostShare = costShare == null || costShare?.outOfPocket == null;
    const renderInNetwork =
        singleEstimateResponse?.claims?.[0]?.procedures?.[0]?.provider?.isInNetwork;
    const tierLevelGacOnly = checkIfClaimIsGACOnly(singleEstimateResponse?.claims?.[0]);
    const providerTierLevel =
        singleEstimateResponse?.claims?.[0]?.procedures?.[0]?.provider?.tierLevel;
    const noOONRatesAvailable = estimateResponse?.noOONRates;
    const hasNoOONBenefits = estimateResponse?.hasNoOONMemberBenefit == true;
    const hasNoGACPACRatesAvailable = estimateResponse?.noInnGACPACRates?.hasNoGACPACRates == true;
    const NoGACPACRatesErrorText = estimateResponse?.noInnGACPACRates?.errorMessage;
    const hasBenefitsWithNoGACPACRates = estimateResponse?.noInnGACPACRates?.hasBenefits == true;
    const carePathServiceTypes = serviceInfo?.fullCarePath?.serviceTypes;
    const singleEstimateIsEmpty = !singleEstimateResponse?.claims;
    const indemnityNoResponse = estimateResponse?.indemnityNoResponse == true;
    const isIndemnity = checkIndemnityCoverages(memberDetails, true);
    // Manual page load apm transaction, used for page load metrics
    const transaction = apm.startTransaction('Single Estimate Page', 'Component Page Load');
    const ref = useRef(null);
    const isDesktopView = useDetectMobile(ref);
    const history = useHistory();
    const { termsAndConditions, selectedService } = formValues;

    const [otherFacilitiesOpen, setOtherFacilitiesOpen] = useState(false);
    const [currentFacility, setCurrentFacility] = useState(0);
    const { ageRestriction } = selectedService?.value?.fullCarePath;
    const displayAgeRestriction = ageRestriction || false;

    const getAccumulatorIndexForLetter = () => {
        let index = 0;
        if (renderInNetwork) {
            index = [
                estimateResponse?.accumulators?.findIndex((cost) => cost.tier === 'IN-NETWORK'),
                estimateResponse?.accumulators?.findIndex((cost) => cost.tier === 'TIER-1'),
                estimateResponse?.accumulators?.findIndex((cost) => cost.tier === 'TIER-2'),
            ].find((el) => el > -1);
        } else {
            index = estimateResponse?.accumulators?.findIndex(
                (cost) => cost.tier === OUT_NETWORK_TIER
            );
        }
        return index;
    };

    const accumulatorIndex = getAccumulatorIndexForLetter();

    const determineAverageCostMessageException = (claimRateSource) => {
        // Applies to Dental FACETS Pre-D and OBH FACETS Pre-D
        // When a Pre-D estimate is generated, the average cost messaging should not be displayed because we are using the rate being returned from Pre-D.
        // GAC or MAC rates are just what is being used as the charge amount.
        const costShareCategory = determineCostShareClaimType(
            estimateResponse?.populationConfig?.categoryList,
            singleEstimateResponse?.coverageType
        );
        return (
            costShareCategory?.config?.rateSource == 'PRE_D' &&
            (claimRateSource == 'GAC' || claimRateSource == 'MAC') &&
            (costShareCategory?.config?.costShareClaimType == 'BEHAVIORAL' ||
                costShareCategory?.config?.costShareClaimType == 'DENTAL')
        );
    };

    // Check whether appliedToDeductible line is visible in cost breakdown
    const networkBasedFamilyStatusIndicator = determineSingleEstimateFamilyStatusIndicator(
        providerTierLevel,
        planBenefits?.nonEmbeddedFamilyStatusIndicator,
        renderInNetwork
    );

    const hasDeductible =
        networkBasedFamilyStatusIndicator == 'FAMILY'
            ? checkIfValidAccumulatorData(
                  estimateResponse?.accumulators?.[accumulatorIndex],
                  FAMILY_DEDUCTIBLE
              )
            : checkIfValidAccumulatorData(
                  estimateResponse?.accumulators?.[accumulatorIndex],
                  INDIVIDUAL_DEDUCTIBLE
              );

    const handleOtherLocationsClose = () => {
        setOtherLocationsOpen(false);
    };

    const handleOtherLocationsOpen = () => {
        setOtherLocationsOpen(true);
    };

    const handleViewSingleProvider = () => {
        history.push(SINGLE_ESTIMATE_ROUTE);
    };

    const [printTermsConditionsText, setPrintTermsConditionsText] = useState(false);
    const [showPriorAuthModel, setShowPriorAuthModel] = useState(false);
    const handleOpenDialog = () => {
        setShowPriorAuthModel(true);
    };
    const handleCloseDialog = () => {
        setShowPriorAuthModel(false);
    };
    const [fulfillmentSuccessSnackbarOpen, setFulfillmentSuccessSnackbarOpen] = useState(false);
    const [fulfillmentFailureSnackbarOpen, setFulfillmentFailureSnackbarOpen] = useState(false);
    const [copySnackbarOpen, setCopySnackbarOpen] = useState(false);
    const [sendEstimatesLoading, setSendEstimatesLoading] = useState(false);
    const [estimateSent, setEstimateSent] = useState(false);
    const [oonDisclaimer, setOonDisclaimer] = useState(true);
    const [hideSendEstimateButton, setHideSendEstimateButton] = useState(false);
    const [showAvgTagModal, setShowAvgTagModal] = React.useState(false);
    const [showUnitMeasureModal, setShowUnitMeasureModal] = React.useState(false);

    const handleFulfillmentSuccessSnackbarClose = () => {
        setFulfillmentSuccessSnackbarOpen(false);
    };

    const handleFulfillmentFailureSnackbarClose = () => {
        setFulfillmentFailureSnackbarOpen(false);
    };

    const setCopySuccess = () => {
        setCopySnackbarOpen(true);
    };

    const handleCopySnackbarClose = () => {
        setCopySnackbarOpen(false);
    };

    const displayNoResults = () => {
        return (
            <Grid item xs={12} sx={classes.marginTop20}>
                {renderHeaderInfo(true)}
                <Typography.H1 align="left" className="tds-text__paragraph--bold">
                    No Results Found
                </Typography.H1>
            </Grid>
        );
    };

    function createRow(desc, qty, visible, styleLeft = null, styleRight = null) {
        return { desc, qty, visible, styleLeft, styleRight };
    }

    const rows = [
        createRow(
            'Your costs may include:',
            '',
            true,
            {
                borderBottomWidth: '0px',
                paddingLeft: '20px',
                paddingTop: '20px',
                paddingBottom: '10px',
                color: '#002677',
            },
            {
                borderBottomWidth: '0px',
                paddingTop: '20px',
                paddingBottom: '10px',
                paddingRight: '20px',
            }
        ),
        createRow(
            'Applied to deductible',
            getAppliedToDeductible(singleEstimateResponse) + unitMessage(carePathServiceTypes),
            hasDeductible,
            {
                borderBottomWidth: '0px',
                paddingLeft: '20px',
                paddingTop: '10px',
                paddingBottom: '10px',
            },
            {
                borderBottomWidth: '0px',
                paddingTop: '10px',
                paddingBottom: '10px',
                paddingRight: '20px',
            }
        ),
        createRow(
            'Copay',
            getCoPay(singleEstimateResponse) + unitMessage(carePathServiceTypes),
            true,
            {
                borderBottomWidth: '0px',
                paddingLeft: '20px',
                paddingTop: '10px',
                paddingBottom: '10px',
            },
            {
                borderBottomWidth: '0px',
                paddingTop: '10px',
                paddingBottom: '10px',
                paddingRight: '20px',
            }
        ),
        createRow(
            'Coinsurance',
            getCoinsurance(singleEstimateResponse) + unitMessage(carePathServiceTypes),
            true,
            {
                borderBottomWidth: '0px',
                paddingTop: '10px',
                paddingLeft: '20px',
                paddingBottom: '20px',
            },
            {
                borderBottomWidth: '0px',
                paddingTop: '10px',
                paddingBottom: '20px',
                paddingRight: '20px',
            }
        ),
    ];

    const pageStyle = `
      @page {
        size: Letter;
      }
    `;
    const componentRef = useRef();
    const onBeforeGetContentResolve = useRef();

    const handleOnBeforeGetContent = useCallback(() => {
        //display terms and conditions text
        setPrintTermsConditionsText(true);
        return new Promise((resolve) => {
            onBeforeGetContentResolve.current = resolve;
            setTimeout(() => {
                //do not display terms and conditions text
                setPrintTermsConditionsText(false);
                resolve();
            }, 200);
        });
    }, [setPrintTermsConditionsText]);

    const reactToPrintContent = useCallback(() => {
        return componentRef.current;
    }, []);

    useEffect(() => {
        const hidingSendEstimateButton = checkForHidingSendEstimateButton(
            memberDetails,
            currentSelectedServiceForDisplay,
            hasNoCostShare
        );
        if (hidingSendEstimateButton) {
            setHideSendEstimateButton(true);
        } else {
            setHideSendEstimateButton(false);
        }
    });

    useEffect(() => {
        if (typeof onBeforeGetContentResolve.current === 'function') {
            onBeforeGetContentResolve.current();
        }
    });

    useEffect(() => {
        setOtherLocationsOpen(false);
        transaction.end();
        return () => {
            setSingleEstimateResponse(null);
        };
    }, []);

    const handlePrint = useReactToPrint({
        pageStyle: pageStyle,
        content: reactToPrintContent,
        documentTitle: 'Estimate',
        onBeforeGetContent: handleOnBeforeGetContent,
        removeAfterPrint: true,
    });

    const handleSendEstimate = () => {
        try {
            const singleScenario = JSON.parse(JSON.stringify(singleEstimateResponse));

            const estimateInfo = formatFulfillmentRequest(
                estimateResponse,
                [singleScenario],
                serviceInfo,
                [provider],
                memberDetails,
                formValues,
                accumulatorIndex
            );
            FulfillmentService.postFulfillment(estimateInfo, getIncrementedCorId())
                .then((resp) => {
                    setFulfillmentSuccessSnackbarOpen(true);
                    setSendEstimatesLoading(false);
                    setEstimateSent(true);
                })
                .catch((err) => {
                    setSendEstimatesLoading(false);
                    console.error(err);
                    setFulfillmentFailureSnackbarOpen(true);
                    return;
                });
        } catch (error) {
            console.error(error);
            setFulfillmentFailureSnackbarOpen(true);
            setSendEstimatesLoading(false);
        }
    };

    const renderHeaderInfo = (noResults = false) => {
        return (
            <div ref={ref}>
                <Grid container>
                    <Grid item>
                        <UtilityIcon size="medium" icon={ArrowBack} color="primaryCTA" />
                    </Grid>
                    <Grid item>
                        {renderInNetwork && !noResults && !tierLevelGacOnly ? (
                            <Typography.Link
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    history.push(ESTIMATES_ROUTE);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key == 'Enter') {
                                        history.push(ESTIMATES_ROUTE);
                                    }
                                }}
                                tabIndex="0"
                            >
                                Back to search results
                            </Typography.Link>
                        ) : (
                            <Typography.Link
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    history.push(SEARCH_ROUTE);
                                    setLoading(false);
                                    handleChangeCustom(null, 'selectedService');
                                    handleChangeCustom(null, 'selectedProvider');
                                }}
                                onKeyDown={(e) => {
                                    if (e.key == 'Enter') {
                                        history.push(SEARCH_ROUTE);
                                        setLoading(false);
                                        handleChangeCustom(null, 'selectedService');
                                        handleChangeCustom(null, 'selectedProvider');
                                    }
                                }}
                                tabIndex="0"
                            >
                                Start new search
                            </Typography.Link>
                        )}
                    </Grid>
                </Grid>
                {!noResults && (
                    <div>
                        <Typography.H1>Healthcare cost estimate</Typography.H1>
                        <Divider sx={classes.divider} data-testid="headerDivider"></Divider>
                    </div>
                )}
            </div>
        );
    };

    /**
     * helper handler function for changeFamilyMember button/link, goes to login page and resets state
     */
    const handleChangeFamilyMember = () => {
        handleReset();
        history.push(LOGIN_ROUTE);
    };

    const showDmeToggle = () => {
        const allowedCodeModifiers = [
            ESTIMATE_HISTORY_TYPES.purchase,
            ESTIMATE_HISTORY_TYPES.rental,
        ];

        const hasAllowedModifier = allowedCodeModifiers.includes(
            serviceInfo?.lineItem?.codeModifier
        );
        const hasRelatedCarePath = serviceInfo?.fullCarePath?.relatedCarePaths?.length != 0;

        if (hasAllowedModifier && hasRelatedCarePath) {
            return true;
        }
        return false;
    };

    const renderPrintEstimate = () => {
        if (integrationType === 'member') {
            return (
                <Grid
                    container
                    justifyContent="flex-end"
                    onClick={handlePrint}
                    sx={{
                        [`@media print`]: {
                            display: 'none',
                        },
                    }}
                >
                    <PrintEstimateOrResultsButton
                        style={{
                            marginLeft: 10,
                            minWidth: 'auto',
                        }}
                        text="Print Estimate"
                        handlePrint={() => {}}
                    />
                </Grid>
            );
        } else {
            return null;
        }
    };

    const renderSendEstimateButton = () => {
        return (
            <Button
                onClick={() => {
                    handleSendEstimate();
                    setSendEstimatesLoading(true);
                }}
                disabled={hideSendEstimateButton}
                buttonType={estimateSent ? 'secondary-two' : 'secondary-one'}
                style={{
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    backgroundColor: estimateSent ? '#007000' : '#FFFFFF',
                    cursor: estimateSent ? 'default' : 'pointer',
                    width: '100%',
                    color: estimateSent ? '#FFFFFF' : '#002677',
                    borderColor: estimateSent ? '#FFFFFF' : '#002677',
                }}
                loading={sendEstimatesLoading}
            >
                {sendEstimateButtonLabel(estimateSent, sendEstimatesLoading)}
            </Button>
        );
    };

    const renderMemberAndServiceInfo = (firstName, lastName, serviceInfo) => {
        const serviceNameToDisplay = getServiceNameToDisplay(serviceInfo);

        return (
            <Grid container>
                <Grid item xs={isDesktopView ? 8 : 12}>
                    <Grid xs={12} item>
                        <Grid
                            container
                            direction={isDesktopView ? 'row' : 'column'}
                            alignItems={isDesktopView ? 'flex-end' : 'flex-start'}
                        >
                            <Grid item>
                                <Typography.H6 style={{ color: '#002677', marginBottom: '8px' }}>
                                    The estimated cost for {`${firstName} ${lastName}`}
                                </Typography.H6>
                            </Grid>
                            <Grid item>
                                <Link underline="hover" noIcon={true}>
                                    <Typography.Paragraph
                                        bodyStyle={3}
                                        style={{
                                            color: '#196ECF',
                                            fontWeight: 600,
                                            fontSize: '14.22px',
                                            marginBottom: '11px',
                                            paddingLeft: isDesktopView ? '18px' : '0px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={handleChangeFamilyMember}
                                        onKeyDown={(e) => {
                                            if (e.key == 'Enter') {
                                                handleChangeFamilyMember();
                                            }
                                        }}
                                        tabIndex="0"
                                    >
                                        Change family member
                                    </Typography.Paragraph>
                                </Link>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid xs={12} item>
                        {isDesktopView ? (
                            <Typography.H5 style={{ color: '#333333' }}>
                                {serviceNameToDisplay}
                            </Typography.H5>
                        ) : (
                            <Typography.H3 style={{ color: '#333333' }}>
                                {serviceNameToDisplay}
                            </Typography.H3>
                        )}
                    </Grid>
                </Grid>
                <Grid item xs={4} hidden={!isDesktopView}>
                    {renderPrintEstimate()}
                    {integrationType === 'advocate' && (
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-end"
                            spacing={1}
                            sx={{
                                paddingTop: '6px',
                                paddingBottom: '2px',
                            }}
                        >
                            {!hideSendEstimateButton && (
                                <Grid item>{renderSendEstimateButton()}</Grid>
                            )}
                            <Grid item>
                                <CopyEstimate
                                    estimate={singleEstimateResponse}
                                    provider={provider}
                                    estimateType={'single'}
                                    setCopySuccess={setCopySuccess}
                                ></CopyEstimate>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        );
    };

    const hasOonCoverage = checkOonCoverage(estimateResponse);

    const renderProcedureDisclaimers = (paragraphs) => {
        if (paragraphs) {
            return paragraphs.map((paragraph, index) => {
                return (
                    <Typography.Paragraph key={`disclaimer-${index}`}>
                        {paragraph}
                    </Typography.Paragraph>
                );
            });
        }
    };

    const renderFulfillmentSnackbars = () => {
        let closeFunction;
        let displayMessage;
        let severityLevel;
        if (fulfillmentSuccessSnackbarOpen) {
            closeFunction = handleFulfillmentSuccessSnackbarClose;
            displayMessage = 'Successfully sent estimate for fulfillment!';
            severityLevel = 'success';
        } else if (fulfillmentFailureSnackbarOpen) {
            closeFunction = handleFulfillmentFailureSnackbarClose;
            displayMessage = 'Failed to Send Estimate';
            severityLevel = 'error';
        }

        return (
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={fulfillmentSuccessSnackbarOpen || fulfillmentFailureSnackbarOpen}
                autoHideDuration={3000}
                onClose={closeFunction}
            >
                <Alert onClose={closeFunction} severity={severityLevel} sx={{ width: '100%' }}>
                    {displayMessage}
                </Alert>
            </Snackbar>
        );
    };

    // Render when oonDisclaimer exists & hasNoOONBenefits is true
    const renderOonBenefitsDisclaimer = () => {
        if (hasNoOONBenefits && oonDisclaimer) {
            return (
                <Box
                    component="div"
                    px={2}
                    sx={{
                        display: 'flex',
                        alignItems: 'start',
                        justifyContent: 'space-between',
                        bgcolor: '#E5F8FB',
                        minHeight: '72px',
                        marginBottom: '12px',
                    }}
                    data-testid="no-oon-benefits-disclaimer"
                >
                    <Box>
                        <Grid
                            container
                            spacing={1}
                            aria-live="polite"
                            display="flex"
                            justifyContent="space-between"
                            alignItems="start"
                            py={1}
                            wrap="nowrap"
                            sx={{
                                paddingTop: '14px',
                                paddingBottom: '14px',
                            }}
                        >
                            <Box
                                sx={{
                                    padding: '14px 14px 14px 14px',
                                }}
                                /**
                                 * This disclaimer will be added to the GENERIC_DISCLAIMERs after a revamp of disclaimers in the future.
                                 */
                            >
                                <Grid item sx={{ display: 'flex' }}>
                                    <FlagIcon style={{ color: '#002677' }} />{' '}
                                    <Typography.Paragraph
                                        style={{
                                            fontWeight: 700,
                                            marginLeft: '1rem',
                                        }}
                                    >
                                        Out-of-Network services are not covered by your plan. <br />
                                        Your plan does not pay any portion of Out-of-Network
                                        services, except in limited circumstances.
                                    </Typography.Paragraph>
                                </Grid>
                                <Grid item>
                                    <Typography.Paragraph>
                                        If you are treated by an out of-network provider, you may
                                        still get a bill for the difference between the amount the
                                        out-of-network provider charges for an item or service and
                                        the amount your plan paid for that same item or service.
                                        This is called <b>balance billing</b>, and this amount is
                                        not included in your estimate. You may reduce your
                                        out-of-pocket expense by seeing an in-network provider.
                                    </Typography.Paragraph>
                                </Grid>
                            </Box>
                        </Grid>
                    </Box>
                    <Grid item sx={{ paddingTop: '24px' }}>
                        <IconButton
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                setOonDisclaimer(false);
                            }}
                            onKeyDown={(e) => {
                                if (e.key == 'Enter' || e.key == ' ') {
                                    setOonDisclaimer(false);
                                }
                            }}
                            aria-label="closeServiceDisclaimer"
                            sx={{
                                '&:focus': {
                                    outline: '#196ecf auto 1px',
                                },
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Box>
            );
        } else {
            return null;
        }
    };

    const renderCostDetailsTable = () => {
        if (renderInNetwork) {
            return (
                <Accordion
                    sx={{
                        boxShadow: 'none',
                        borderBottom: '1px solid #d7d7d7',
                        borderTop: '1px solid #d7d7d7',
                    }}
                >
                    <AccordionSummary style={{ padding: '0px' }} expandIcon={<ExpandMoreIcon />}>
                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Typography.H6
                                style={{
                                    color: '#333333',
                                    marginBottom: '0px',
                                }}
                            >
                                {isDesktopView ? 'Total estimated out-of-pocket' : 'You Pay'}
                            </Typography.H6>
                            <Typography.H6
                                data-testid="youPayBreakdown"
                                style={{
                                    color: '#333333',
                                    paddingLeft: '100px',
                                    marginBottom: '0px',
                                    fontWeight: 500,
                                }}
                            >
                                <b>{`${getMemberPays(singleEstimateResponse)}`}</b>
                                {' ' + unitMessage(carePathServiceTypes)}
                            </Typography.H6>
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Table sx={{ width: '100%' }} data-testid="costDetails-table">
                            <TableBody
                                style={{
                                    backgroundColor: '#F6F6F6',
                                    padding: '10px',
                                }}
                            >
                                {rows.map(
                                    (row) =>
                                        row.visible && (
                                            <TableRow
                                                sx={{ border: 'none' }}
                                                key={row.desc}
                                                hover={true}
                                            >
                                                <TableCell style={row.styleLeft}>
                                                    <Grid container alignItems="center">
                                                        {row.desc}
                                                    </Grid>
                                                </TableCell>
                                                <TableCell align="right" style={row.styleRight}>
                                                    <Grid
                                                        container
                                                        justifyContent="flex-end"
                                                        sx={{
                                                            width: '100%',
                                                        }}
                                                    >
                                                        {row.qty}
                                                    </Grid>
                                                </TableCell>
                                            </TableRow>
                                        )
                                )}
                            </TableBody>
                        </Table>
                    </AccordionDetails>
                </Accordion>
            );
        } else {
            return null;
        }
    };

    const renderPacGacDisclaimers = (
        claimHasNoCostShare,
        claimHasNoGACPACRatesAvailable,
        claimRateSource
    ) => {
        if (
            claimRateSource == 'GAC' ||
            claimRateSource == 'PAC' ||
            claimRateSource == 'OutOfNetworkGeo' ||
            claimHasNoGACPACRatesAvailable ||
            claimHasNoCostShare
        ) {
            return (
                <PacGacDisclaimer
                    claimHasNoGACPACRatesAvailable={claimHasNoGACPACRatesAvailable}
                    claimHasNoCostShare={claimHasNoCostShare}
                    NoGACPACRatesErrorText={NoGACPACRatesErrorText}
                    dontShowAverageCostText={determineAverageCostMessageException(claimRateSource)}
                />
            );
        } else {
            return null;
        }
    };

    /**
     * Function to display important messages to user in UI like when there is a failure from backend.
     * @param {*} message
     * @returns
     */
    const displayImportantMessage = (message) => {
        return (
            <Grid container direction="row" alignItems="flex-end" id="here">
                <Box
                    component="div"
                    my={3}
                    px={3}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        bgcolor: '#FEF9EA',
                        padding: '1rem',
                        width: '100%',
                    }}
                >
                    <Box>
                        <Grid
                            container
                            spacing={1}
                            display="flex"
                            direction="row"
                            justifyContent="space-between"
                            alignItems="start"
                            py={1}
                            wrap="nowrap"
                        >
                            <Grid
                                item
                                sx={{
                                    position: 'relative',
                                }}
                            >
                                <Square
                                    style={{
                                        color: '#19191A',
                                    }}
                                    sx={{
                                        position: 'absolute',
                                        height: '12px',
                                        width: '30px',
                                        left: '5px',
                                        top: '16.5px',
                                    }}
                                />
                                <Warning
                                    sx={{
                                        position: 'sticky',
                                        zIndex: '1',
                                    }}
                                    style={{
                                        color: '#F5B700',
                                    }}
                                />{' '}
                            </Grid>
                            <Grid item>
                                <Typography.Paragraph
                                    data-testid="no-oon-rates"
                                    style={{
                                        fontFamily: '"UHC Sans", Arial, sans-serif',
                                        fontStyle: 'Normal',
                                        fontSize: '16px',
                                        lineHeight: '22px',
                                    }}
                                >
                                    {message}
                                </Typography.Paragraph>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Grid>
        );
    };

    const renderIndemnityNoResponseText = () => {
        if (indemnityNoResponse) {
            return displayImportantMessage(INDEMNITY_NO_RATES.text);
        } else {
            return null;
        }
    };

    const renderNoBenefitErrorText = () => {
        if (noOONRatesAvailable || hasNoOONBenefits) {
            return displayImportantMessage(noOONRatesAvailable);
        } else {
            return null;
        }
    };

    const renderProviderInformation = (
        singleClaim,
        claimProviderType,
        renderPhysicianAndFacility
    ) => {
        let providerInfoForDisplay = provider;
        const isSecondFacilityClaim = checkIfSecondFacilityClaim(
            renderPhysicianAndFacility,
            claimProviderType
        );
        if (isSecondFacilityClaim) {
            providerInfoForDisplay = provider?.facilitiesData[currentFacility] ?? null;
        }

        return (
            <Grid
                item
                xs={5}
                sx={{
                    paddingLeft: isDesktopView && '40px',
                    display: 'flex',
                }}
            >
                <Grid
                    container
                    direction="column"
                    justifyContent={!isSecondFacilityClaim ? 'space-between' : 'start'}
                >
                    <Grid item>
                        {isDesktopView ? (
                            <Typography.H4
                                style={{
                                    marginBottom: '0px',
                                    fontWeight: 700,
                                }}
                                data-testid={`provider-name-${singleClaim.id}`}
                            >
                                {displayProviderName(providerInfoForDisplay)}
                            </Typography.H4>
                        ) : (
                            <Typography.H6
                                style={{
                                    marginBottom: '0px',
                                    fontWeight: 700,
                                }}
                                data-testid={`provider-name-${singleClaim.id}`}
                            >
                                {displayProviderName(providerInfoForDisplay)}
                            </Typography.H6>
                        )}
                    </Grid>
                    <Grid item>
                        <Typography.Paragraph
                            bodyStyle={1}
                            data-testid={`provider-specialization-${singleClaim.id}`}
                        >
                            {displayProviderSpecialty(providerInfoForDisplay)}
                        </Typography.Paragraph>
                    </Grid>
                    {providerInfoForDisplay && !isSecondFacilityClaim && (
                        <Grid item sx={{ marginBottom: '20px' }}>
                            {!isIndemnity[
                                selectedService?.value?.fullCarePath?.coverageTypeCode
                            ] && (
                                <Grid container direction="row" alignItems="center">
                                    <CheckCircleIcon
                                        sx={{
                                            color: '#007000',
                                            marginRight: '8px',
                                        }}
                                    />
                                    <Typography.Paragraph
                                        bodyStyle={2}
                                        className="tds-text__paragraph--bold"
                                        data-testid={`provider-network-status-${singleClaim.id}`}
                                        style={{
                                            color: provider && '#007000',
                                            marginBottom: '0px',
                                        }}
                                    >
                                        In-Network Provider
                                    </Typography.Paragraph>
                                </Grid>
                            )}
                        </Grid>
                    )}
                    {!isSecondFacilityClaim && (
                        <Grid item sx={{ marginBottom: '16px' }}>
                            <Button
                                data-testid={`change-provider-button-${singleClaim.id}`}
                                onClick={() => {
                                    history.push(ESTIMATES_ROUTE);
                                }}
                            >
                                Change Provider {'>'}
                            </Button>
                        </Grid>
                    )}
                    {isSecondFacilityClaim && (
                        <Grid item sx={{ marginTop: '20px' }}>
                            <Button
                                data-testid={`change-facility-button-${singleClaim.id}`}
                                onClick={() => setOtherFacilitiesOpen(true)}
                                onKeyDown={(e) => {
                                    if (e.key == 'Enter' || e.key == ' ') {
                                        setOtherFacilitiesOpen(true);
                                    }
                                }}
                            >
                                Change Facility {'>'}
                            </Button>
                        </Grid>
                    )}
                    {!isSecondFacilityClaim && (
                        <Grid item>
                            <Link
                                role="button"
                                aria-haspopup="dialog"
                                onClick={handleOtherLocationsOpen}
                                onKeyDown={(e) => {
                                    if (e.key == 'Enter' || e.key == ' ') {
                                        handleOtherLocationsOpen();
                                    }
                                }}
                                tabIndex="0"
                                text="Other locations & costs for this provider"
                                aria-label="Other locations & costs for this provider"
                                data-testid={`otherLocationsLink-${singleClaim.id}`}
                                sx={{ paddingBottom: '3.5px' }}
                            />
                        </Grid>
                    )}
                </Grid>
            </Grid>
        );
    };

    const renderOutOfNetworkProviderTag = (singleClaim) => {
        return (
            <Grid container direction="column" spacing={1} style={{ marginBottom: '30px' }}>
                <Grid item>
                    <Typography.Paragraph
                        bodyStyle={2}
                        className="tds-text__paragraph--bold"
                        data-testid={`provider-network-status-${singleClaim?.id}`}
                        sx={{
                            paddingBottom: '16px',
                            alignItems: 'center',
                        }}
                    >
                        <span
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                verticalAlign: 'baseline',
                                color: '#c40000',
                                paddingTop: '10px !important',
                            }}
                        >
                            <CheckCircleIcon
                                sx={{
                                    justifyContent: 'center',
                                    paddingRight: 0.75,
                                }}
                            />
                            Out-of-network provider
                        </span>
                    </Typography.Paragraph>
                </Grid>
            </Grid>
        );
    };

    const renderSendEstimateForMobileAdvocateView = () => {
        return (
            <Grid item>
                <Box
                    sx={{
                        whiteSpace: 'nowrap',
                        marginBottom: '8px',
                        [`@media print`]: {
                            display: 'none',
                        },
                        height: '40px',
                    }}
                >
                    {!hideSendEstimateButton && renderSendEstimateButton()}
                </Box>
                <Box
                    sx={{
                        whiteSpace: 'nowrap',
                        marginBottom: '32px',
                        [`@media print`]: {
                            display: 'none',
                        },
                        height: '40px',
                    }}
                >
                    <CopyEstimate
                        estimate={singleEstimateResponse}
                        provider={provider}
                        estimateType={'single'}
                        setCopySuccess={setCopySuccess}
                    />
                </Box>
            </Grid>
        );
    };

    const renderPrintEstimateForMobileMemberView = () => {
        return (
            <Grid item>
                <Box
                    sx={{
                        [`@media print`]: {
                            display: 'none',
                        },
                        whiteSpace: 'nowrap',
                        marginBottom: '32px',
                    }}
                >
                    <PrintEstimateOrResultsButton
                        style={{
                            height: 'auto',
                            paddingTop: '6px',
                            paddingBottom: '2px',
                            minWidth: 'auto',
                            width: '100%',
                        }}
                        text="Print Estimate"
                        handlePrint={handlePrint}
                    />
                </Box>
            </Grid>
        );
    };

    const renderDivider = () => {
        return (
            <Grid
                item
                xs={1}
                sx={{
                    paddingBottom: !isDesktopView && '20px',
                    paddingTop: !isDesktopView && '5px',
                }}
            >
                <Divider
                    orientation={
                        isDesktopView ||
                        !noOONRatesAvailable ||
                        !hasNoOONBenefits ||
                        !indemnityNoResponse
                            ? 'vertical'
                            : 'horizontal'
                    }
                    hidden={!(renderInNetwork && !tierLevelGacOnly)}
                />
            </Grid>
        );
    };
    const renderYouPayAmount = (singleClaim) => {
        return (
            <Grid item>
                <Grid container direction="row">
                    <Grid item>
                        <Typography.H1
                            data-testid={`you-pay-${singleClaim.id}`}
                            style={{
                                fontSize: '48px',
                                marginBottom: '0px',
                            }}
                        >
                            {getMemberPays(singleClaim)}
                            {displayAgeRestriction &&
                                memberDetails?.sourceCode !== UMR_SOURCECODE && <sup>*</sup>}{' '}
                            {showRentalDuration(serviceInfo) ? rentalDurationText(serviceInfo) : ''}
                        </Typography.H1>
                    </Grid>
                    {showPerUnitMeasure(carePathServiceTypes) && (
                        <Grid item sx={{ alignSelf: 'flex-end' }}>
                            <Typography.H6
                                data-testid="youPayUnit"
                                style={{
                                    font: 'UHC2020 Sans',
                                    fontSize: '20px',
                                    marginBottom: '6px',
                                    fontWeight: '600',
                                    lineHeight: '24px',
                                    paddingLeft: '8px',
                                    paragraph: '24px',
                                }}
                            >
                                {unitMessage(carePathServiceTypes)}
                                {'*'}
                            </Typography.H6>
                        </Grid>
                    )}
                    {[PER_UNIT_MEASURES.ambulance, PER_UNIT_MEASURES.perUnit].includes(
                        carePathServiceTypes
                    ) && (
                        <UnitMeasureMessage
                            showUnitMeasureModal={showUnitMeasureModal}
                            carePathServiceTypes={carePathServiceTypes}
                            setShowUnitMeasureModal={setShowUnitMeasureModal}
                        />
                    )}
                </Grid>
                {showPerUnitMeasure(carePathServiceTypes) && (
                    <Grid container>
                        <Grid item>
                            <Typography.Paragraph
                                data-testid="youPayUnitMessage"
                                style={{
                                    font: 'UHC Sans',
                                    color: '#002677',
                                    marginBottom: '0px',
                                    fontWeight: '500',
                                    fontSize: '14.22px',
                                    paddingBottom: '10px',
                                    lineHeight: '16px',
                                    paragraph: '12px',
                                }}
                            >
                                *Your provider may order multiples, which can increase the cost
                                estimate.
                            </Typography.Paragraph>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        );
    };

    const renderProviderInformationCard = (singleClaim, serviceInfo, claimHasNoCostShare) => {
        const renderPhysicianAndFacility = checkiIfRenderPhysicianAndFacility(serviceInfo);

        const claimProviderType = getProviderType(singleClaim);

        const claimIsGACOnly = checkIfClaimIsGACOnly(singleClaim);

        // label is presently claim but the data refers to the first procedure data so naming convention will likely change to suit
        const claimRateSource = singleClaim?.procedures[0]?.rateSource;
        const claimRate = singleClaim?.procedures[0]?.rate;

        const claimHasNoGACPACRatesAvailable = !claimRate && !claimRateSource;

        return (
            <Card
                sx={{
                    px: isDesktopView ? '40px' : '16px',
                    py: isDesktopView ? '32px' : '20px',
                    marginBottom: '16px',
                }}
                aria-label={`youPayAndProviderInfoCard-${singleClaim.id}`}
                data-testid={`youPayAndProviderInfoCard-${singleClaim.id}`}
            >
                {checkDisplayProviderCard(hasNoGACPACRatesAvailable) && (
                    <Grid
                        container
                        direction={
                            isDesktopView &&
                            !noOONRatesAvailable &&
                            !hasNoOONBenefits &&
                            !indemnityNoResponse
                                ? 'row'
                                : 'column'
                        }
                    >
                        {!claimHasNoCostShare && (
                            <Grid item xs={5}>
                                {(!renderInNetwork || !provider) &&
                                    renderOutOfNetworkProviderTag(singleClaim)}
                                <Grid container item>
                                    <Grid
                                        container
                                        item
                                        direction={isDesktopView ? 'row' : 'column'}
                                    >
                                        {renderInNetwork && provider && (
                                            <Typography.Paragraph
                                                bodyStyle={1}
                                                className="tds-text__paragraph--bold"
                                                style={{ marginBottom: '0px' }}
                                            >
                                                You pay
                                            </Typography.Paragraph>
                                        )}
                                        {(!renderInNetwork || !provider) && (
                                            <Typography.Paragraph
                                                bodyStyle={1}
                                                className="tds-text__paragraph--bold"
                                                style={{ marginBottom: '0px' }}
                                            >
                                                Estimated out-of-pocket cost
                                            </Typography.Paragraph>
                                        )}
                                    </Grid>
                                    {!noOONRatesAvailable &&
                                        !hasNoOONBenefits &&
                                        !indemnityNoResponse &&
                                        renderYouPayAmount(singleClaim)}
                                    <AgeRestrictionMessage />
                                </Grid>
                                {renderInNetwork &&
                                    !isIndemnity[
                                        selectedService?.value?.fullCarePath?.coverageTypeCode
                                    ] && (
                                        <>
                                            <Grid
                                                item
                                                hidden={!isDesktopView}
                                                sx={{ paddingBottom: '14px' }}
                                            >
                                                <Grid container data-testid="geoAverageCostBlock">
                                                    <GeoAverageCost
                                                        geoAverageCost={singleClaim?.geoAverageCost}
                                                        carePathServiceTypes={carePathServiceTypes}
                                                    />{' '}
                                                </Grid>
                                            </Grid>
                                        </>
                                    )}
                            </Grid>
                        )}
                        {!claimHasNoCostShare && renderDivider()}
                        {renderInNetwork &&
                            !claimIsGACOnly &&
                            renderProviderInformation(
                                singleClaim,
                                claimProviderType,
                                renderPhysicianAndFacility
                            )}
                    </Grid>
                )}
                <Grid item xs={12} sx={{ paddingTop: '32px' }}>
                    {renderPacGacDisclaimers(
                        claimHasNoCostShare,
                        claimHasNoGACPACRatesAvailable,
                        claimRateSource
                    )}
                </Grid>
            </Card>
        );
    };

    const hasResultsToDisplay =
        singleEstimateResponse ||
        !hasNoVisionCost ||
        noOONRatesAvailable ||
        hasNoOONBenefits ||
        hasNoGACPACRatesAvailable ||
        indemnityNoResponse;

    const hasPreventive = selectedService?.value?.fullCarePath?.preventive;

    return (
        <Box sx={{ width: '100%' }} data-testid="estimatesPage">
            {renderFulfillmentSnackbars()}
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={copySnackbarOpen}
                autoHideDuration={2000}
                onClose={handleCopySnackbarClose}
            >
                <Alert onClose={handleCopySnackbarClose} severity="success" sx={{ width: '100%' }}>
                    Copied to Clipboard!
                </Alert>
            </Snackbar>
            {hasResultsToDisplay ? (
                <Box ref={componentRef}>
                    {renderHeaderInfo()}
                    {renderMemberAndServiceInfo(
                        memberDetails?.demographics?.name?.firstName,
                        memberDetails?.demographics?.name?.lastName,
                        serviceInfo
                    )}
                    {hasPreventive && (
                        <EstimateToggleComponentSingleEstimate
                            setLoading={setLoading}
                            loading={loading}
                            setProvider={setProvider}
                            setCurrentSelectedServiceForDisplay={
                                setCurrentSelectedServiceForDisplay
                            }
                            provider={provider}
                            toggleType={'PreventiveAndDiagnostic'}
                            serviceInfo={serviceInfo}
                            setCurrentFacility={setCurrentFacility}
                        />
                    )}
                    {showDmeToggle() && (
                        <EstimateToggleComponentSingleEstimate
                            setLoading={setLoading}
                            loading={loading}
                            setProvider={setProvider}
                            setCurrentSelectedServiceForDisplay={
                                setCurrentSelectedServiceForDisplay
                            }
                            provider={provider}
                            toggleType={'RentalAndPurchase'}
                            serviceInfo={serviceInfo}
                            setCurrentFacility={setCurrentFacility}
                        />
                    )}
                    {
                        <ServiceNoteDisclaimers
                            serviceNoteDisclaimers={singleEstimateResponse?.serviceNotes}
                            handleOpenDialog={handleOpenDialog}
                        />
                    }
                    {
                        <PriorAuthDialog
                            showPriorAuthModel={showPriorAuthModel}
                            handleCloseDialog={handleCloseDialog}
                        />
                    }
                    {!hasNoVisionCost ? (
                        <VisionEstimateComponent
                            isDesktopView={isDesktopView}
                            inNetworkBenefits={inNetworkBenefits}
                            outOfNetworkBenefits={outOfNetworkBenefits}
                        />
                    ) : (
                        <Box>
                            {renderOonBenefitsDisclaimer()}
                            {renderNoBenefitErrorText()}
                            {renderIndemnityNoResponseText()}
                            {hasBenefitsWithNoGACPACRates &&
                                singleEstimateIsEmpty &&
                                renderPacGacDisclaimers(
                                    hasNoCostShare,
                                    hasNoGACPACRatesAvailable,
                                    ''
                                )}
                            <div data-testid="providerAndFacilityCardGroup">
                                {!estimateSuppressedByCustomDisclaimer(
                                    singleEstimateResponse?.serviceNotes,
                                    singleEstimateResponse?.costShare
                                ) &&
                                    singleEstimateResponse?.claims?.map((singleClaim, index) => {
                                        const claimHasNoCostShare =
                                            singleClaim?.costShare == null ||
                                            singleClaim?.costShare?.outOfPocket == null;

                                        return (
                                            <div
                                                style={classes.marginBottom20}
                                                key={`section-${singleClaim.id}`}
                                            >
                                                <Typography.H6
                                                    style={{
                                                        color: '#000000',
                                                        marginBottom: '8px',
                                                        fontSize: '1rem',
                                                    }}
                                                >
                                                    {getCardTitle(serviceInfo, singleClaim)}
                                                </Typography.H6>
                                                {renderProviderInformationCard(
                                                    singleClaim,
                                                    serviceInfo,
                                                    claimHasNoCostShare
                                                )}
                                            </div>
                                        );
                                    })}
                            </div>
                            {singleEstimateResponse?.[0] &&
                                !isDesktopView &&
                                !hasNoGACPACRatesAvailable &&
                                !hasNoCostShare && (
                                    <GeoAverageCost geoAverageCost={geoAverageCost} />
                                )}
                            {!hasNoOONBenefits && (
                                <Grid
                                    sx={{
                                        marginTop: '40px',
                                        marginBottom: isDesktopView ? '60px' : '27px',
                                    }}
                                    container
                                    direction={isDesktopView ? 'row' : 'column'}
                                    justifyContent={'space-between'}
                                >
                                    {!noOONRatesAvailable &&
                                    !hasNoGACPACRatesAvailable &&
                                    !hasNoCostShare &&
                                    !indemnityNoResponse ? (
                                        <Grid
                                            item
                                            xs={6}
                                            sx={{ paddingBottom: isDesktopView ? '0px' : '40px' }}
                                        >
                                            <Typography.H4
                                                style={{
                                                    marginBottom: 0,
                                                    color: '#333333',
                                                    paddingBottom: isDesktopView ? '28px' : '20px',
                                                }}
                                            >
                                                {memberDetails?.demographics?.name?.firstName}'s
                                                estimated cost
                                            </Typography.H4>
                                            {renderInNetwork && (
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        paddingRight: '16px',
                                                    }}
                                                >
                                                    <Typography.H6
                                                        style={{
                                                            color: '#333333',
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        {`Total estimated ${
                                                            showRentalDuration(serviceInfo)
                                                                ? rentalPeriodText(serviceInfo)
                                                                : ''
                                                        } cost ${unitMeasureMessage(
                                                            carePathServiceTypes
                                                        )} before coverage`}
                                                    </Typography.H6>

                                                    <Typography.H6
                                                        style={{
                                                            color: '#333333',
                                                            fontWeight: 500,
                                                        }}
                                                    >{`${
                                                        singleEstimateResponse &&
                                                        getTotalBeforeCoverage(
                                                            singleEstimateResponse
                                                        )
                                                    } ${unitMessage(
                                                        carePathServiceTypes
                                                    )}`}</Typography.H6>
                                                </Box>
                                            )}
                                            {/* <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    marginTop: '-10px',
                                                }}
                                            >
                                                {costScale &&
                                                    renderInNetwork &&
                                                    !isIndemnity[
                                                        selectedService?.value?.fullCarePath
                                                            ?.coverageTypeCode
                                                    ] && (
                                                        <AverageThresholdTag
                                                            costScale={costScale}
                                                            cost={costShare?.outOfPocket}
                                                            currentDialogState={showAvgTagModal}
                                                            setDialogState={setShowAvgTagModal}
                                                            data-testid="geoAvgThresholdTag"
                                                        />
                                                    )}
                                            </Box> */}
                                            {/* //commenting out the average tag for now but will put behind feature flag */}
                                            {renderInNetwork && (
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        paddingRight: '16px',
                                                    }}
                                                >
                                                    <Typography.H6
                                                        style={{
                                                            color: '#333333',
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        Your Healthcare plan pays
                                                    </Typography.H6>
                                                    <Typography.H6
                                                        style={{
                                                            color: '#333333',
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        {estimatedCostDisplaySingle(
                                                            singleEstimateResponse,
                                                            costShare
                                                        )}
                                                        {' ' + unitMessage(carePathServiceTypes)}
                                                    </Typography.H6>
                                                </Box>
                                            )}
                                            {(!renderInNetwork || !provider) && (
                                                <OONTextBlockJSX
                                                    singleEstimateResponse={singleEstimateResponse}
                                                    hasOonCoverage={hasOonCoverage}
                                                    hasDeductible={hasDeductible}
                                                    memberDetails={memberDetails}
                                                />
                                            )}
                                            {renderCostDetailsTable()}
                                        </Grid>
                                    ) : (
                                        <Grid
                                            item
                                            xs={6}
                                            sx={{ paddingBottom: isDesktopView ? '0px' : '40px' }}
                                        />
                                    )}
                                    <Grid
                                        item
                                        xs={6}
                                        sx={{ paddingLeft: isDesktopView ? '56px' : '0px' }}
                                    >
                                        {renderInNetwork ||
                                        hasOonCoverage ||
                                        hasNoGACPACRatesAvailable ||
                                        indemnityNoResponse
                                            ? renderPlanSummaryAccumulators(
                                                  renderInNetwork,
                                                  estimateResponse,
                                                  isDesktopView,
                                                  memberDetails?.demographics?.name?.firstName,
                                                  printTermsConditionsText
                                              )
                                            : renderNoOonCoverageDisclaimer()}
                                    </Grid>
                                </Grid>
                            )}
                            {(renderInNetwork || hasOonCoverage || noOONRatesAvailable) && (
                                <>
                                    <Divider hidden={isDesktopView} />
                                    {!isDesktopView && (
                                        <Grid
                                            container
                                            direction="row"
                                            alignItems="center"
                                            sx={{ marginBottom: '27px', marginTop: '27px' }}
                                        >
                                            <Grid item sx={{ paddingRight: '8px' }}>
                                                <div
                                                    style={{
                                                        height: '16px',
                                                        width: '16px',
                                                        borderRadius: '50%',
                                                        backgroundColor: '#002677',
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Typography.Paragraph
                                                    data-testid="progressBarLegend"
                                                    style={{ marginBottom: '0px' }}
                                                >
                                                    Total amount before this procedure
                                                </Typography.Paragraph>
                                            </Grid>
                                        </Grid>
                                    )}
                                </>
                            )}
                            {!(
                                noOONRatesAvailable ||
                                hasNoOONBenefits ||
                                (!renderInNetwork && !hasBenefitsWithNoGACPACRates) ||
                                indemnityNoResponse
                            ) && (
                                <Divider
                                    data-testid="header-divider"
                                    style={{ marginBottom: isDesktopView ? '32px' : '54px' }}
                                />
                            )}
                            <Grid container direction="column">
                                {!isDesktopView &&
                                    integrationType === 'member' &&
                                    renderPrintEstimateForMobileMemberView()}
                                {!isDesktopView &&
                                    integrationType === 'advocate' &&
                                    renderSendEstimateForMobileAdvocateView()}
                            </Grid>
                            {singleEstimateResponse
                                ? renderProcedureDisclaimers(singleEstimateResponse.disclaimers)
                                : null}
                        </Box>
                    )}
                    {!hasNoVisionCost ? renderProcedureDisclaimers(VISION_DISCLAIMERS) : null}
                    {printTermsConditionsText && (
                        <DisclaimersText genericDisclaimers={termsAndConditions.value} />
                    )}
                </Box>
            ) : (
                displayNoResults()
            )}
            {provider && renderInNetwork ? (
                <OtherLocationsModal
                    estimate={singleEstimateResponse}
                    provider={provider}
                    handleViewSingleProvider={handleViewSingleProvider}
                    topLocation={topLocation}
                    setTopLocation={setTopLocation}
                    otherLocationsOpen={otherLocationsOpen}
                    handleOtherLocationsClose={handleOtherLocationsClose}
                    key={`estimate-${singleEstimateResponse ? singleEstimateResponse.id : ''}`}
                />
            ) : null}
            {provider && renderInNetwork ? (
                <OtherFacilitiesModal
                    provider={provider}
                    dialogOpen={otherFacilitiesOpen}
                    handleDialogClose={() => setOtherFacilitiesOpen(false)}
                    key={`estimate-${singleEstimateResponse ? singleEstimateResponse.id : ''}`}
                    currentFacility={currentFacility}
                    setCurrentFacility={setCurrentFacility}
                />
            ) : null}
        </Box>
    );
}
